import moment from 'moment';

export const quoteTitleRules = [
  { required: true, message: 'Title is required' },
  {
    max: 250,
    message: 'Title cannot be longer than 250 characters',
  },
];

export const bidExpirationRules = (bidExpirationDateValue, bidExpirationTimeZoneInfo) => [
  {
    required: false,
    validator: () => {
      if (bidExpirationDateValue && bidExpirationTimeZoneInfo) {
        const deadlineInTZ = moment.tz(
          bidExpirationDateValue.format('YYYY-MM-DD HH:mm'),
          'YYYY-MM-DD HH:mm',
          bidExpirationTimeZoneInfo.ianaTimeZoneId,
        );

        const nowInTZ = moment.tz(bidExpirationTimeZoneInfo.ianaTimeZoneId);

        if (deadlineInTZ.isBefore(nowInTZ, 'minute')) {
          return Promise.reject('Bid Expiration Date must be greater or equal to the current time');
        }
      }

      return Promise.resolve();
    },
  },
];
